/**
 * Every Likely to Fill string, in one place so a copy change is a one-file edit.
 *
 * Labels and alert sentences follow the GOTU-13065 Jira ticket and the Crabs
 * Figma page "Likely to fill updates"; product may still reword the alerts.
 */

export const TREATMENT_LABELS = {
  veryLikely: 'Very Likely to Fill',
  likely: 'Likely to fill.',
  lessLikely: 'Less likely to fill',
  warning: 'Less likely to fill',
  unlikely: 'Unlikely to fill',
};

// `amount` is the first whole-dollar shortfall past the band above, e.g. "$4+".
export const TREATMENT_MESSAGES = {
  warning: {
    hygienistDentist: (amount) =>
      `Shifts ${amount} below your market rate are much less likely to get candidates` +
      ' and be worked.',
    assistantFrontDesk: (amount) =>
      `Shifts ${amount} below your market rate are much less likely to get candidates`,
  },
  unlikely: {
    hygienistDentist: (amount) => `Shifts ${amount} below your market rate rarely get candidates.`,
    assistantFrontDesk: (amount) =>
      `Shifts ${amount} below your market rate have a dramatically lower chance of being worked.`,
  },
};
